.link-privacy-modal {
  color: var(--ai12zBot-v2-privacy-link-color);
  font-size: var(--ai12zBot-v2-privacy-link-font-size);
}

.privacy-msg {
  font-size: var(--ai12zBot-v2-privacy-text-font-size);
  color: var(--ai12zBot-v2-privacy-text-color);
}
